module.exports = __webpack_public_path__ + "img/dance-work-icon4.edde11dc.png";